import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { useParams } from "react-router-dom";
import { MembershipTransferOutHistoryTable } from "@icoach/documents/table/";
import { Button, Card, Typography } from "@curves/ui-base";
import useDocMembershipTransferOutApi from "@apis/useDocMembershipTransferOutApi";
import { PEOPLE_TYPE } from "@icoach/constants/";

const noShowNewForms = [PEOPLE_TYPE.UNCONFIRMTRANSFEROUTMEMBER, PEOPLE_TYPE.ALREADYTRANSFEROUTMEMBER];

const MembershipTransferOutHistory = props => {
	const { onBlankContractClick } = props;
	const history = useHistory();
	const { peopleType: peopleTypeProps, referenceID: referenceIDProps } = useParams();
	const { postTransferOutContractHistoryApi } = useDocMembershipTransferOutApi();
	const [sourceData, setSourceData] = useState([]);

	// 按鈕 建立新表單
	const handleCreateButtonClick = () => {
		if (noShowNewForms.includes(String(peopleTypeProps))) return;
		onBlankContractClick && onBlankContractClick();
	};

	// 讀取該對象的歷史紀錄
	const getInitPeopleRecordOverview = async () => {
		const params = { type: peopleTypeProps, id: referenceIDProps };
		const resp = await postTransferOutContractHistoryApi(params);
		if (resp) setSourceData(resp);
	};

	useEffect(
		() => {
			getInitPeopleRecordOverview();
		},
		// eslint-disable-next-line
		[]
	);

	useEffect(
		() => {
			// 重刷頁面才會用 REPLACE
			if (history.action === "REPLACE") {
				getInitPeopleRecordOverview();
			}
		},
		// eslint-disable-next-line
		[history.location]
	);

	return (
		<Card>
			<Card.CardContent className="document-history-list">
				<header className={"page-header"}>
					<Typography className={"page-header-title"} variant={"h3"}>
						歷史紀錄
					</Typography>
					{!noShowNewForms.includes(String(peopleTypeProps)) && (
						<div className="btn-group">
							<Button name="create" variant="outlined" color="secondary" onClick={handleCreateButtonClick}>
								建立新表單
							</Button>
						</div>
					)}
				</header>
				<MembershipTransferOutHistoryTable className={"theme-gray"} sourceData={sourceData} onReload={getInitPeopleRecordOverview} />
			</Card.CardContent>
		</Card>
	);
};

export default MembershipTransferOutHistory;
